import React from 'react';
import ReactDOM from 'react-dom';
import classnames from 'classnames';
import { AnimatePresence, motion } from 'framer-motion';
import { u as useRefocusOnActivator_2 } from './useRefocusOnActivator-CiCzAHtv.js';
import { u as useOnKeyDown_2 } from './useOnKeyDown-t-UhpB2o.js';
import { u as useFocusTrap_2 } from './useFocusTrap-CsPhaFeT.js';
import { H as Heading } from './Heading-DX1jjqTV.js';
import { B as Button } from './Button-DJQVVE0-.js';
import { B as ButtonDismiss } from './ButtonDismiss-C4D25Ln_.js';

var styles = {"container":"QGRLFHPoV5E-","overlay":"_4WzGOMUGj5I-","modal":"WLId2NJBQcQ-","header":"wjrPpIUNNrk-","closeButton":"rKvigUnOyYE-","actionBar":"_62c8HLZFwvs-","leftAction":"Xl1Ptn-P9Ew-","rightAction":"p2s7GtpoZz0-"};

var sizes = {"small":"_65IpUjOZiBg-","large":"Cpwnmw65caA-"};

function Modal({ open = false, title, size, dismissible = true, children, primaryAction, secondaryAction, tertiaryAction, onRequestClose, }) {
    const modalClassName = classnames(styles.modal, size && sizes[size]);
    useRefocusOnActivator_2(open);
    const modalRef = useFocusTrap_2(open);
    useOnKeyDown_2(handleRequestClose, "Escape");
    const template = (React.createElement(AnimatePresence, null, open && (React.createElement("div", { ref: modalRef, role: "dialog", className: styles.container, tabIndex: 0 },
        React.createElement(motion.div, { key: styles.overlay, className: styles.overlay, onClick: onRequestClose, initial: { opacity: 0 }, animate: { opacity: 0.8 }, exit: { opacity: 0 }, transition: { duration: 0.2 } }),
        React.createElement(motion.div, { key: styles.modal, className: modalClassName, initial: { scale: 0.9, opacity: 0 }, animate: { scale: 1, opacity: 1 }, exit: { scale: 0.9, opacity: 0 }, transition: {
                duration: 0.2,
                ease: "easeInOut",
            } },
            title != undefined && (React.createElement(Header, { title: title, dismissible: dismissible, onRequestClose: onRequestClose })),
            children,
            React.createElement(Actions, { primary: primaryAction, secondary: secondaryAction, tertiary: tertiaryAction }))))));
    return (globalThis === null || globalThis === void 0 ? void 0 : globalThis.document)
        ? ReactDOM.createPortal(template, document.body)
        : template;
    function handleRequestClose() {
        if (open && onRequestClose) {
            onRequestClose();
        }
    }
}
function Header({ title, dismissible, onRequestClose }) {
    return (React.createElement("div", { className: styles.header, "data-testid": "modal-header" },
        React.createElement(Heading, { level: 2 }, title),
        dismissible && (React.createElement("div", { className: styles.closeButton },
            React.createElement(ButtonDismiss, { onClick: onRequestClose, ariaLabel: "Close modal" })))));
}
function Actions({ primary, secondary, tertiary }) {
    const shouldShow = primary != undefined || secondary != undefined || tertiary != undefined;
    if (secondary != undefined) {
        secondary = Object.assign({ type: "primary", variation: "subtle" }, secondary);
    }
    if (tertiary != undefined) {
        tertiary = Object.assign({ type: "secondary", variation: "destructive" }, tertiary);
    }
    return (React.createElement(React.Fragment, null, shouldShow && (React.createElement("div", { className: styles.actionBar },
        React.createElement("div", { className: styles.rightAction },
            primary && React.createElement(Button, Object.assign({}, primary)),
            secondary && React.createElement(Button, Object.assign({}, secondary))),
        tertiary && (React.createElement("div", { className: styles.leftAction },
            React.createElement(Button, Object.assign({}, tertiary))))))));
}

export { Modal as M };
